import React from 'react';
import PropTypes from 'prop-types';
import { size } from "../../../utils/size";
import { LOCATION } from "../../../utils/default-strings";
import { Divider } from "../../elements/Divider";
import { GoogleMap } from "../../elements/GoogleMap";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { Heading } from "../../typography/Heading";
import { ShowOn } from "../../layout/ShowOn";
import { Subheading } from "../../typography/Subheading";
import { withResponsive } from "../../../utils/with-responsive";
import { getTransportOptionsMarkup } from "./utils/getTransportOptionsMarkup";
import { getGoogleMapHeight } from "./utils/getGoogleMapHeight";
import { getLocationDescription } from "./utils/getLocationDescription";

var Component = function Component(_ref) {
  var id = _ref.id,
      apiKey = _ref.apiKey,
      headingText = _ref.headingText,
      isShowingApproximateLocation = _ref.isShowingApproximateLocation,
      isShowingExactLocation = _ref.isShowingExactLocation,
      isUserOnMobile = _ref.isUserOnMobile,
      latitude = _ref.latitude,
      locationDescription = _ref.locationDescription,
      locationSummary = _ref.locationSummary,
      longitude = _ref.longitude,
      transportOptions = _ref.transportOptions;
  return React.createElement(Grid, {
    id: id,
    isStackable: true
  }, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, null, headingText), React.createElement(Subheading, null, locationSummary)), !!locationDescription && getLocationDescription(locationDescription), size(transportOptions) > 0 && React.createElement(ShowOn, {
    computer: true,
    parent: GridColumn,
    parentProps: {
      computer: 6,
      tablet: 12
    },
    tablet: true,
    widescreen: true
  }, getTransportOptionsMarkup(transportOptions)), React.createElement(GridColumn, {
    width: 12
  }, React.createElement(GoogleMap, {
    apiKey: apiKey,
    height: getGoogleMapHeight(isUserOnMobile),
    isShowingApproximateLocation: isShowingApproximateLocation,
    isShowingExactLocation: isShowingExactLocation,
    latitude: latitude,
    longitude: longitude
  })), size(transportOptions) > 0 && React.createElement(ShowOn, {
    mobile: true,
    parent: GridColumn,
    parentProps: {
      width: 12
    }
  }, React.createElement(Divider, null), getTransportOptionsMarkup(transportOptions)));
};

Component.displayName = 'Location';
Component.defaultProps = {
  id: null,
  apiKey: undefined,
  headingText: LOCATION,
  isShowingApproximateLocation: false,
  isShowingExactLocation: false,
  locationDescription: null,
  transportOptions: []
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  apiKey: PropTypes.string,
  headingText: PropTypes.string,
  id: PropTypes.string,
  isShowingApproximateLocation: PropTypes.bool,
  isShowingExactLocation: PropTypes.bool,
  isUserOnMobile: PropTypes.bool.isRequired,
  latitude: PropTypes.number.isRequired,
  locationDescription: PropTypes.string,
  locationSummary: PropTypes.string.isRequired,
  longitude: PropTypes.number.isRequired,
  transportOptions: PropTypes.arrayOf(PropTypes.shape({
    distance: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }))
} : {};
export var ComponentWithResponsive = withResponsive(Component);